export * from './lib/pages/personal-details/personal-details.component';
export * from './lib/personal-details.routes';
